'use strict';

exports.__esModule = true;
exports.Media = exports.withBreakpoints = undefined;
var _BreakpointsContext = require("./BreakpointsContext");
Object.defineProperty(exports, 'Media', {
  enumerable: true,
  get: function get() {
    return _BreakpointsContext.Consumer;
  }
});
var _ReactBreakpoints = require("./ReactBreakpoints");
var _ReactBreakpoints2 = _interopRequireDefault(_ReactBreakpoints);
var _withBreakpoints2 = require("./withBreakpoints");
var _withBreakpoints3 = _interopRequireDefault(_withBreakpoints2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.withBreakpoints = _withBreakpoints3.default;
exports.default = _ReactBreakpoints2.default;